function generateCarUrl({
  id,
  make,
  model,
  registration_year,
  registration_month,
  price,
}){
  return `/lista-carros-usados-stand-pombal/${make}-${model}-${registration_year}-${registration_month}-${price}€-${id}`
}

export default generateCarUrl;